/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumption_Comparison_Missing_ReferenceInputs */



/**
* | output |
* | --- |
* | "No reference period is set for this building: set it in its settings." |
*
* @param {Consumption_Comparison_Missing_ReferenceInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_comparison_missing_reference = /** @type {((inputs?: Consumption_Comparison_Missing_ReferenceInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Comparison_Missing_ReferenceInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("No reference period is set for this building: set it in its settings.")
	return /** @type {LocalizedString} */ ("Aucune période de référence n'est définie pour ce bâtiment : renseignez-la dans ses paramètres.")
});